import { Component, OnInit, Directive } from "@angular/core";
import { ModalController, NavParams } from "@ionic/angular";
import { AppService } from "src/app/app.service";
import { Subject } from "rxjs";
import { Global } from "src/global";
import { Router, ActivatedRoute } from "@angular/router";
import { DomSanitizer } from "@angular/platform-browser";
import { ElementRef, ViewChild } from "@angular/core";

@Component({
  selector: "app-modal",
  templateUrl: "./modal.page.html",
  styleUrls: ["./modal.page.scss"],
})
export class ModalPage implements OnInit {
  paramObject: any;
  inputValue: string = "";
  ContentUploaded: any;
  ContentViewing: any;
  pdfSrc: string = "";
  uploadDone: boolean;
  PDFLocation: string;
  loadingDone: boolean = false;
  sanitizedURL: any;
  fileTypeError: boolean = false;
  uploadBusy: boolean = false;
  ContentUploadedMultipleFiles: any[] = [];
  totalExcelFilesUploaded: number;
  totalExcelFilesProcessed: number;

  @ViewChild("fileInput") fileInput: ElementRef;

  constructor(
    private modalController: ModalController,
    private navParams: NavParams,
    private appservice: AppService,
    public globals: Global,
    private router: Router,
    public sanitizer: DomSanitizer
  ) {}

  dismissModal() {
    this.modalController.dismiss();
  }

  ngOnInit(): void {
    console.table(this.navParams);
    this.paramObject = this.navParams.data.paramObject;

    if (this.paramObject.modalType == "contentViewer") {
      this.displayContent(this.paramObject.Content_GUID);
    }
  }

  triggerFileInput() {
    this.fileInput.nativeElement.click();
  }

  handleDragOver(event: DragEvent): void {
    event.preventDefault();
  }

  handleDrop(event: DragEvent): void {
    event.preventDefault();
    const files = event.dataTransfer.files;

    this.handleFileInput;
    this.processFiles(files);
  }

  displayContent(Content_GUID: string) {
    //no slash found
    if (Content_GUID.indexOf(".") == -1) {
      var formData = new FormData();
      formData.append("Content_GUID", Content_GUID);

      this.appservice.GetContentDetail(formData).subscribe((res) => {
        try {
          this.ContentViewing = JSON.parse(res.toString());
          this.contentViewingSelector();
        } catch (e) {}
      });
    } else {
      var ContentViewing = {
        Location: "",
        contentType: "",
        url: "",
        Description: "",
        Tags: "",
      };

      ContentViewing.Location = Content_GUID;
      ContentViewing.url = "";
      ContentViewing.contentType = "";

      this.ContentViewing = ContentViewing;
      this.contentViewingSelector();
    }
  }

  contentViewingSelector() {
    if (
      this.ContentViewing.Location.toLowerCase().includes("jpg") ||
      this.ContentViewing.Location.toLowerCase().includes("jpeg") ||
      this.ContentViewing.Location.toLowerCase().includes("gif") ||
      this.ContentViewing.Location.toLowerCase().includes("png")
    ) {
      this.ContentViewing.contentType = "picture";
      this.ContentViewing.url =
        this.globals.XRSBaseURLWebLMS + this.ContentViewing.Location;
    }

    if (this.ContentViewing.Location.toLowerCase().includes("pdf")) {
      this.ContentViewing.ContentType = "document";
      this.ContentViewing.url =
        this.globals.XRSBaseURLWebLMS + this.ContentViewing.Location;

      this.PDFLocation = this.ContentViewing.url;
    }

    if (
      this.ContentViewing.Location.toLowerCase().includes("mp4") ||
      this.ContentViewing.Location.toLowerCase().includes("mpeg4")
    ) {
      this.ContentViewing.ContentType = "video";
      this.ContentViewing.url =
        this.globals.XRSBaseURLWebLMS + this.ContentViewing.Location;
    }

    if (this.ContentViewing.Location.toLowerCase().includes("htm")) {
      this.ContentViewing.ContentType = "HTML";
      this.ContentViewing.url =
        this.globals.XRSBaseURLWebLMS + this.ContentViewing.Location;
      this.sanitizedURL = this.sanitizer.bypassSecurityTrustResourceUrl(
        this.ContentViewing.url
      );
      //this.router.navigateByUrl(this.ContentViewing.url);
    }

    this.loadingDone = true;
  }

  deleteFile(index: number): void {
    this.ContentUploadedMultipleFiles.splice(index, 1);

    if (this.ContentUploadedMultipleFiles.length > 0) {
      const nextFile = this.ContentUploadedMultipleFiles[0];
      this.displayContent(nextFile.GUID);
    } else {
      this.uploadDone = null;
      this.ContentUploaded = null;
      this.ContentViewing = null;
      this.ContentUploadedMultipleFiles = [];
    }
  }

  deleteSingleFile(): void {
    this.uploadDone = null;
    this.ContentUploaded = null;
    this.ContentViewing = null;
    this.ContentUploadedMultipleFiles = [];
  }

  handleFileInput(event: any): void {
    const files: FileList = event.target.files;
    this.processFiles(files);
  }

  private processFiles(files: FileList): void {
    this.uploadDone = false;

    for (let i = 0; i < files.length; i++) {
      const file: File = files.item(i);
      console.log(`Selected File: ${file.name}`);

      var subject = new Subject<any>();
      var formData = new FormData();
      formData.append("UploadedFile", file, file.name);
      formData.append("Description", file.name);
      formData.append("User_GUID", this.globals.XRSUser.GUID);
      formData.append("Site_GUID", this.globals.XRSUser.Site_GUID);
      formData.append("Site_ID", this.globals.XRSUser.Site_ID);

      this.appservice.UploadPost(formData).subscribe(
        (res) => {
          this.uploadDone = true;
          try {
            this.ContentUploaded = JSON.parse(res.toString());
            this.ContentUploaded.url =
              this.globals.GetXRSCustomContentURL() + this.ContentUploaded.GUID;
            this.ContentUploaded.contentType = this.ContentUploaded.GUID;
            this.ContentUploadedMultipleFiles.push(this.ContentUploaded);
            this.displayContent(this.ContentUploaded.GUID);
          } catch (e) {
            console.error("Error parsing response:", e);
          }
        },
        (error) => {
          console.error("Upload error:", error);
        }
      );
    }
  }

  handleExcelFileInput(files: any) {
    this.totalExcelFilesUploaded = this.totalExcelFilesUploaded = files.length;
    this.totalExcelFilesProcessed = this.totalExcelFilesUploaded;
    for (let i = 0; i < files.length; i++) {
      const file: File = files.item(i);

      if (
        file &&
        file.type !==
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" &&
        file.type !== "application/vnd.ms-excel"
      ) {
        this.fileTypeError = true;
      } else {
        this.fileTypeError = false;
        this.uploadBusy = true;
      }

      this.uploadDone = false;

      var subject = new Subject<any>();
      var formData = new FormData();
      formData.append("UploadedFile", file, file.name);
      formData.append("Description", file.name);
      formData.append("User_GUID", this.globals.XRSUser.GUID);
      formData.append("Site_GUID", this.globals.XRSUser.Site_GUID);
      formData.append("Site_ID", this.globals.XRSUser.Site_ID);

      this.appservice.UploadPost(formData).subscribe((res) => {
        this.totalExcelFilesProcessed--;
        this.uploadDone = true;
        try {
          this.ContentUploaded = JSON.parse(res.toString());
          this.ContentUploaded.url =
            this.globals.GetXRSCustomContentURL() + this.ContentUploaded.GUID;

          this.ContentUploadedMultipleFiles.push(this.ContentUploaded);

          this.displayContent(this.ContentUploaded.GUID);
          //this.ContentUploaded = null;
        } catch (e) {}
      });
    }
  }

  handleImportZip(files: any) {
    this.uploadDone = false;

    var subject = new Subject<any>();
    var formData = new FormData();
    formData.append("UploadedFile", files.item(0), files.item(0).name);
    formData.append("User_GUID", this.globals.XRSUser.GUID);
    formData.append("Site_GUID", this.globals.XRSUser.Site_GUID);
    formData.append("Site_ID", this.globals.XRSUser.Site_ID);

    this.appservice.ImportLesson(formData).subscribe(async (res) => {
      this.uploadDone = true;
      try {
        await this.modalController.dismiss(res);
      } catch (e) {}
    });
  }

  async onThumbnailClick(
    event: any,
    key: any,
    Content_GUID: any,
    modalHeading: any
  ) {
    var paramObject = {
      modalType: "contentViewer",
      modalBodyText: "",
      modalHeaderText: modalHeading,
      Content_GUID: Content_GUID,
    };

    const modal = await this.modalController.create({
      component: ModalPage,
      componentProps: {
        paramObject: paramObject,
      },
      cssClass: "modal-fullscreen",
    });

    modal.onDidDismiss().then((dataReturned) => {
      if (dataReturned !== null) {
      }
    });
    return await modal.present();
  }

  onInputChange(event: any) {
    this.inputValue = event.target.value;
  }

  async onButtonPress(value: any) {
    
    if (value == "no") {
      await this.modalController.dismiss(false);
    } else if (value == "yes") {
      await this.modalController.dismiss(true);
    } else {
      await this.modalController.dismiss(value);
    }
  }

  async onCancel() {
    await this.modalController.dismiss(null);
  }

  async onClose() {
    await this.modalController.dismiss(this.inputValue);
  }

  async onCloseUpload() {
    if (this.paramObject.modalType == "contentViewer") {
      const formData: FormData = new FormData();

      formData.append("Content", JSON.stringify(this.ContentViewing));

      this.appservice.SetContentDetail(formData).subscribe((res) => {
        try {
        } catch (e) {}
      });
    }

    if (
        (this.ContentUploadedMultipleFiles?.length ?? 0) > 1 &&
        this.paramObject.modalType === "ExcelImport"
      ) {
        await this.modalController.dismiss(this.ContentUploadedMultipleFiles);
      } else {
        await this.modalController.dismiss(this.ContentUploaded);
      }
    }

  async onCancelupload() {
    await this.modalController.dismiss(null);
  }
}
